import { render, staticRenderFns } from "./Swoosh.vue?vue&type=template&id=70308abb&scoped=true&functional=true"
var script = {}
import style0 from "./Swoosh.vue?vue&type=style&index=0&id=70308abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "70308abb",
  null
  
)

export default component.exports